// @flow
import { _get, _post } from "./methods";

export default {
  curzon: {
    listMappings: (params: any) => _get("/admin/showtimes/curzon/mappings", params),
    saveMapping: (params: any) => _post("/admin/showtimes/curzon/mappings", params),
    importSnapshot: (params: any) =>
      _post("/admin/showtimes/curzon/import_snapshot", params)
  },
  picturehouse: {
    listMappings: (params: any) => _get("/admin/showtimes/picturehouse/mappings", params),
    saveMapping: (params: any) => _post("/admin/showtimes/picturehouse/mappings", params),
    importSnapshot: (params: any) =>
      _post("/admin/showtimes/picturehouse/import_snapshot", params)
  }
};
